import { useEffect, useState } from "react";
import "./App.css";

function App() {
  const [timeLeft, setTimeLeft] = useState("00:00");

  function updateCountdown() {
    console.log("Updating countdown");
    const target = new Date("2025-10-08T02:30:00Z"); // 8:00am IST is 2:30am UTC
    const now = new Date();
    let diff = Math.max(0, target - now);

    const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
    diff %= 1000 * 60 * 60;
    const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, "0");
    diff %= 1000 * 60;
    const seconds = String(Math.floor(diff / 1000)).padStart(2, "0");

    setTimeLeft(`${hours}:${minutes}:${seconds}`);
  }

  useEffect(() => {
    updateCountdown();
    const interval = setInterval(updateCountdown, 60);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="App">
      <div className="content">
        <h1>{timeLeft}</h1>
        <p>
          left before I can see you again, I can feel you again, I can hold your
          hand again. Please never leave me like this again, EVER.
        </p>
      </div>
      <footer>
        <p>{`Made with ❤️ by your better half (if you think me so)`}</p>
      </footer>
    </div>
  );
}

export default App;
